import React, { JSX } from 'react';
import { Placeholder, ComponentRendering } from '@sitecore-content-sdk/nextjs';

type DynamicPlaceholderProps = {
  rendering: ComponentRendering;
};

const PartialDesignDynamicPlaceholder = (props: DynamicPlaceholderProps): JSX.Element => (
  <Placeholder
    name={props.rendering?.params?.sig || ''}
    rendering={props.rendering}
    disableSuspense={true} // Disable suspense so we do not get "Loading component" https://sitecore.stackexchange.com/questions/40201/loading-component-started-appearing-after-nextjs-upgrade
  />
);

export default PartialDesignDynamicPlaceholder;
